import { useCallback, useEffect, useState } from 'react';

const STORAGE_KEY = 'favorite_events';

const readFavorites = (): string[] => {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]');
    } catch {
        return [];
    }
};

export const useFavorites = () => {
    const [favoriteIds, setFavoriteIds] = useState<Set<string>>(() => new Set(readFavorites()));

    useEffect(() => {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(Array.from(favoriteIds)));
    }, [favoriteIds]);

    const toggleFavorite = useCallback((eventId: string) => {
        setFavoriteIds((prev) => {
            const next = new Set(prev);
            if (next.has(eventId)) {
                next.delete(eventId);
            } else {
                next.add(eventId);
            }
            return next;
        });
    }, []);

    const isFavorite = useCallback((eventId: string) => favoriteIds.has(eventId), [favoriteIds]);

    return { favoriteIds, toggleFavorite, isFavorite, favoriteCount: favoriteIds.size };
};
